import Swal from 'sweetalert2'

export const userKey = '_Sollicita.ParecerIA'
export const rememberKey = '_Sollicita.ParecerIA_remember'
export const navegacaoKey = '_Sollicita.Navegacao'

export var urlApi = ''
export var urlApiSollicita = ''
export var idModulo = 41
export var urlPortal = '';
export var urlBase = 'sollicita.com.br';
export var urlSignal = 'https://sollai.com.br/';
export var urlSite = 'https://sollai.com.br/';
export var msgManutencao = true;
export var urlSuporte = 'https://gnp.negociospublicos.net.br/np/suporte/login?';

var dev = false;
if (dev) {
    urlApi = 'https://localhost:44324/api/v1'
    urlApiSollicita = 'http://localhost:82/NP/SollicitaAdmin/api'
    urlPortal = 'http://localhost:8081/';
    urlSignal = 'https://localhost:44324/';
    urlSuporte = 'http://localhost:82/np/suporte/login?'
} else {
    urlApi = 'https://api.sollai.com.br/api/v1';
    urlApiSollicita = 'https://gnp.negociospublicos.net.br/NP/SollicitaAdmin/api'
    urlPortal = 'https://portal.' + urlBase + '/';
    urlSignal = 'https://api.sollai.com.br/';
    urlBase = 'https://sollicita.com.br/';
}

export function avisoErro(e) {
    if (e && e.response && e.response.data) {
        //alert(e.response.data);
        Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: e.response.data,
        })
    } else if (typeof e === 'string') {
        //alert(e);
        Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: e,
        })
    } else {
        //alert('Erro');
        Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: e,
        })
    }
}

export function avisoSucesso(msg) {
    Swal.fire({
        icon: 'success',
        title: 'Sucesso',
        text: msg,
    })
}

export function avisoToast(msg, icon = 'success') {

    const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
    })

    Toast.fire({
        icon: icon,
        title: msg
    })
}

export default {
    userKey,
    rememberKey,
    urlApi,
    avisoErro,
    avisoSucesso,
    urlApiSollicita,
    avisoToast,
    idModulo,
    urlPortal,
    urlSignal,
    urlSite,
    msgManutencao,
    urlSuporte,
    navegacaoKey
}